module.exports = __webpack_public_path__ + "img/P51-en.e3ca68c9.png";